import { render, staticRenderFns } from "./ConsultarAutorizacaoFornecimento.vue?vue&type=template&id=c5d828c4&scoped=true"
import script from "./ConsultarAutorizacaoFornecimento.vue?vue&type=script&lang=js"
export * from "./ConsultarAutorizacaoFornecimento.vue?vue&type=script&lang=js"
import style0 from "./ConsultarAutorizacaoFornecimento.vue?vue&type=style&index=0&id=c5d828c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d828c4",
  null
  
)

export default component.exports